import React from 'react';
import {
  Grid,
  Box,
  Typography
} from '@material-ui/core';
import store from "../../redux/store";
import axiosAgent from "../../plugins/axios";

const PageError = (props) => {
  const handleSend = async () => {
    const userId = store.getState()?.app?.user?.id;
    await axiosAgent("post", "/frontlog/create", {
      "user_id": userId,
      "url": window.location.href,
      "message": props?.error?.message,
      "stack": props?.error?.stack,
      "component_stack": props?.componentStack
    }).then((res) => true).catch(() => false);
  }
  React.useEffect(() => {
    (async () => {
      await handleSend();
    })();
  }, []);
  return (
    <Grid container justify={'center'} alignItems={'center'} style={{ flex: 1, height: '100%', backgroundColor: '#212529' }}>
      <Grid item xs={12}>
        <Box mb={2}>

          <Typography variant={'h1'} align={'center'} style={{ color: 'white' }}>Ошибка системы</Typography>
        </Box>

        <Box mb={2}>
          <Typography variant={'h5'} align={'center'} style={{ color: 'white' }}>Мы уже получили сообщение об ошибке системы.</Typography>
          <Typography variant={'h5'} align={'center'} style={{ color: 'white' }}>Приступаем к расмотрению ошибки.</Typography>
        </Box>

        <Box></Box>
      </Grid>
    </Grid>
  )
}

export default PageError
